import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { NumericInput } from '@mc/react-core';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import classNames from 'classnames';

export type NumProps = Omit<
  VFFieldProps<React.ComponentProps<typeof NumericInput>>,
  'onValueChange'
>;
export const Number = React.forwardRef<HTMLInputElement, NumProps>(
  (
    {
      name,
      validate,
      className,
      onChange: customOnChange,
      inputClassName,
      label,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: FieldRenderProps<number>) => {
            const handleChange = React.useCallback(
              (numValue: number, strValue: string) => {
                let realVal: number | undefined = numValue;

                const isEmpty = strValue === '';
                if (
                  (!isEmpty &&
                    (isNaN(numValue) ||
                      strValue.indexOf('.') !== -1 ||
                      strValue.indexOf('e') !== -1 ||
                      strValue.indexOf(',') !== -1)) ||
                  (other.min !== undefined && numValue < other.min) ||
                  (other.max !== undefined && numValue > other.max)
                ) {
                  return;
                }

                if (strValue === '') {
                  realVal = undefined;
                }
                onChange({ target: { name, value: realVal } });
                customOnChange && customOnChange(realVal as any);
              },
              [customOnChange, onChange, name]
            );

            return (
              <NumericInput
                buttonPosition={"none"}
                {...other}
                className={classNames(inputClassName, 'bp3-fill')}
                // @ts-ignore
                ref={ref}
                {...nother}
                name={name}
                {...other}
                disabled={disabled}
                onValueChange={handleChange}
                value={value === undefined ? '' : value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
